//const { url } = require("inspector");

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        /**/this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
this.preselectSellingPlanFromUrl();  // 👈 NEW FUNCTION CALL

// Skip selling plan listener for FlexPet products
if (!document.querySelector('#flexpet-customizer')) {
  this.initSellingPlanChangeListener();  // 👈 Add listener to handle changes
}

// 🔥 Update price on first load
this.updatePriceOnInitialLoad();
this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
}
      initSellingPlanChangeListener() {
        const subscriptionOptions = this.querySelectorAll('#subscription-options input[type="radio"][name="subscription"]');
        //const variantsOptions = this.querySelectorAll('#subscription-options input[type="radio"][name="ot"]');
        subscriptionOptions.forEach(radio => {
          radio.addEventListener('change', () => {
            const qtyInput = this.querySelector('quantity-input input.quantity__input');
            const planId = radio.dataset.sellingPlan;
            const planIndex = radio.dataset.planIndex;
            const variantId = radio.dataset.variantId;
            let newPrice = radio.dataset.price;
            let comparePrice = radio.dataset.compare;
             console.log('Subscription radio changed:', planIndex, newPrice, comparePrice);
            // Update price display
            // this.updatePriceDisplay(newPrice, comparePrice);
            // Update URL to reflect selected plan
            const url = new URL(window.location.href);
            if (planIndex) {
              url.searchParams.set('plan', planIndex);
              // capture radio attr value called data-qty-plan-'planIndex']' and set it to quantityInput value
              const qtyPlanAttr = `data-qty-plan-${planIndex}`;
              console.log('qtyPlanAttr:', qtyPlanAttr, qtyInput,  qtyInput.getAttribute(qtyPlanAttr));
              /*if ( qtyInput.hasAttribute(qtyPlanAttr) ) {
                //console.log('Setting quantityInput value from attribute:', qtyPlanAttr);
                qtyInput.setAttribute('value', qtyInput.getAttribute(qtyPlanAttr));
                console.log('Setting quantityInput value to:', qtyInput , qtyInput.getAttribute(qtyPlanAttr));
                let qtyValue = qtyInput.getAttribute(qtyPlanAttr);
                this.specialPriceUpdate(radio);
              } else {
                qtyInput.value = 1; // Default to 1 if no specific quantity is set
              }*/
              
            } else {
              url.searchParams.delete('plan');
            }

            if (radio) {
              console.log('Setting quantityInput value from radio data-qty-plan:', radio.dataset.qtyPlan);
              this.specialPriceUpdate(radio);
            }
            
            window.history.replaceState({}, '', url.toString());
            console.log('executing handleOptionValueCHange.,,,')
            /**/this.handleOptionValueChange.bind(this);
            this.dispatchEvent(new CustomEvent('sellingPlanChanged', {
              detail: { sellingPlanId: planId, variantId: variantId, price: newPrice },
              bubbles: true
            }));

          });
        });
        /*variantsOptions.forEach(radio => {
          radio.addEventListener('change', () => {
            console.log('Variant radio changed:', radio);
            const planId = radio.dataset.sellingPlan;
            const variantId = radio.dataset.variantId;
            let newPrice = radio.dataset.price;
            let comparePrice = radio.dataset.compare;

            // Update price display
            this.updatePriceDisplay(newPrice, comparePrice);

            // Update URL to reflect selected plan
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variantId);
            if (planId) {
              url.searchParams.set('plan', planId);
            } else {
              url.searchParams.delete('plan');
            }
            window.history.replaceState({}, '', url.toString());

            this.dispatchEvent(new CustomEvent('sellingPlanChanged', {
              detail: { sellingPlanId: planId, variantId: variantId, price: newPrice },
              bubbles: true
            }));
          });
        });
        */
        //
        const allOptions = document.querySelectorAll('#subscription-options label');
        const variantIdInput = document.querySelector('input[name="id"]');
        //console.log('initSellingPlanChangeListener All options:', allOptions, variantIdInput);
        allOptions.forEach(label => {
          label.addEventListener('click', () => {
            console.log('Label clicked:', label);
            // Remove highlighting from others
            allOptions.forEach(opt => opt.classList.remove('border-blue-500', 'bg-blue-50'));
            label.classList.add('border-blue-500', 'bg-blue-50');
            const inputId = label.getAttribute('for');
            const input = document.getElementById(inputId);
            
            console.log('Selected input!!! :', input, input.id);
            
            if (input) {
              document.querySelector('input[name="selling_plan"]').value = input.dataset.sellingPlan || '';
              variantIdInput.value = input.dataset.variantId || variantIdInput.value;
            } else {
              console.warn('No matching input found for label:', label);
            }
            // if input with ID "one-time" is checked, expand "variants-wrapper" div
            /*if (input.id === 'one-time') {
              if (document.querySelector('.variant-wrapper')) {
                document.querySelector('.variant-wrapper').style.maxHeight = 'none';
              }
              if (document.querySelector('.plans-wrapper')) {
              document.querySelector('.plans-wrapper').style.maxHeight = '0';
              }
              // capture url param "variant" and check the input that match with that id
              const urlParams = new URLSearchParams(window.location.search);
              const variantId = urlParams.get('variant');
              if (variantId) {
                const variantInput = document.querySelector(`input[name="ot"][value="${variantId}"]`);
                if (variantInput) {
                  variantInput.checked = true;
                  let newPrice = variantInput.dataset.price;
                  let comparePrice = variantInput.dataset.compare;
                  this.updatePriceDisplay(newPrice, comparePrice);
                }
              }
            } else if ( input.id == 'sbs' ) {
               if (document.querySelector('.variant-wrapper')) {
              document.querySelector('.variant-wrapper').style.maxHeight = '0';
              }
              if (document.querySelector('.plans-wrapper')) {
              document.querySelector('.plans-wrapper').style.maxHeight = 'none';
              }
              // capture url param "plan" and check the input that match with that id
              const urlParams = new URLSearchParams(window.location.search);
              const planId = urlParams.get('plan');
              const variantId = urlParams.get('variant');
              if (planId) {
                const planInput = document.querySelector(`input[name="subscription"][data-selling-plan="${planId}"]`);
                if (planInput) {
                  planInput.checked = true;
                  let newPrice = planInput.dataset.price;
                  let comparePrice = planInput.dataset.compare;
                this.updatePriceDisplay(newPrice, comparePrice);
                }
              } else if (variantId) {
                const variantInput = document.querySelector(`input[name="subscription"][data-variant-id="${variantId}"]`);
                if (variantInput) {
                  variantInput.checked = true;
                  let newPrice = variantInput.dataset.price;
                  let comparePrice = variantInput.dataset.compare;
                  this.updatePriceDisplay(newPrice, comparePrice);
                }
              }
            }*/
          });
        });
        //this.initQuantityHandlers();
      }

      specialPriceUpdate(radio) {
        console.log(radio);
        if (radio) {
          // capture radio data-final-price 
          const priceItemLast = this.querySelector('.price__sale .price-item.price-item--last');
          const finalPrice = radio.dataset.priceFinal;
          if (priceItemLast) {
            priceItemLast.innerHTML = finalPrice;
          }
          // same for compare price
          const priceItemCompare = this.querySelector('.price__sale .price-item.price-item--regular');
          if (priceItemCompare) {
            priceItemCompare.innerHTML = radio.dataset.compare;
          }
          this.querySelector('.price__container .price__regular').style.display = 'none';
          this.querySelector('.price__container .price__sale').style.display = 'flex';
        }
        /*console.log('Special Price Update:', qtyValue, newPrice, comparePrice);
        const priceRegular = this.querySelector('.price__regular .price-item--regular');
        const priceItemLast = this.querySelector('.price__sale .price-item.price-item--last');
        const priceBadgeSale = this.querySelector('.price__badge-sale');
        if (priceBadgeSale) {
          priceBadgeSale.classList.add('tw-hidden');
        }
          if (qtyValue == 1) {
            this.querySelector('.price__container .price__regular').style.display = 'none';
            this.querySelector('.price__container .price__sale').style.display = 'flex';
            console.log('Updating regular price:', newPrice, priceRegular, qtyValue, (newPrice * qtyValue));
            const currentPrice = parseFloat(newPrice.replace(/[^0-9.-]+/g, ''));
            const finalPrice = currentPrice * qtyValue;
            priceRegular.innerHTML = '$' + finalPrice;
            priceItemLast.innerHTML = '$' + finalPrice;
            console.log('Final Price:', finalPrice);
            const originalPrice = parseFloat(comparePrice.replace(/[^0-9.-]+/g, ''));
            const discountPercentage = ((originalPrice - currentPrice) / originalPrice) * 100;
            console.log(`Discount Percentage: ${discountPercentage}%`, comparePrice, originalPrice, newPrice, currentPrice);
            // convert discountPercetage to positive number if its negative
            if (priceBadgeSale) {
              priceBadgeSale.innerHTML = `Save ${Math.round(discountPercentage)}%`;
              priceBadgeSale.classList.remove('tw-hidden');
            }
          } else if (qtyValue > 1) {

            if (comparePrice > newPrice) {
              const priceItemCompare = this.querySelector('.price__sale .price-item.price-item--regular');
              if (priceItemLast) {
                console.log('Updating last price...', newPrice, priceItemLast, qtyValue, (newPrice * qtyValue));
                let promoLastPrice = newPrice * qtyValue;
                priceItemLast.innerHTML = promoLastPrice;
              }
              if (priceItemCompare) {
                console.log('Updating compare price:', comparePrice);
                priceItemCompare.innerHTML = comparePrice;
                this.querySelector('.price__container .price__regular').style.display = 'none';
                this.querySelector('.price__container .price__sale').style.display = 'flex';
              }
              const originalPrice = parseFloat(comparePrice.replace(/[^0-9.-]+/g, ''));
              const currentPrice = parseFloat(newPrice.replace(/[^0-9.-]+/g, ''));
              const discountPercentage = ((originalPrice - currentPrice) / originalPrice) * 100;
              console.log(`Discount Percentage: ${discountPercentage}%`, comparePrice, originalPrice, newPrice, currentPrice);
              // convert discountPercetage to positive number if its negative
              if (priceBadgeSale) {
                priceBadgeSale.innerHTML = `Save ${Math.round(discountPercentage)}%`;
                priceBadgeSale.classList.remove('tw-hidden');
              }
            }
          }*/
      }

      updatePriceDisplay(newPrice, comparePrice) {
        const priceRegular = this.querySelector('.price__regular .price-item--regular');
        const priceItemLast = this.querySelectorAll('.price__sale .price-item.price-item--last');
        const priceBadgeSale = this.querySelector('.price__badge-sale');
        if (priceBadgeSale) {
          priceBadgeSale.classList.add('tw-hidden');
        }
        if (priceRegular) {
          console.log('Updating regular price:', newPrice, priceRegular);
          priceRegular.innerHTML = newPrice;
        }
        
        if (comparePrice > newPrice) {
          const priceItemCompare = this.querySelector('.price__sale .price-item.price-item--regular');
          if (priceItemLast) {
            console.log('Updating last price:', newPrice, priceItemLast);
            priceItemLast.innerHTML = newPrice;
          }
          if (priceItemCompare) {
            console.log('Updating compare price:', comparePrice);
            priceItemCompare.innerHTML = comparePrice;
            this.querySelector('.price__container .price__regular').style.display = 'none';
            this.querySelector('.price__container .price__sale').style.display = 'flex';
          }
          const originalPrice = parseFloat(comparePrice.replace(/[^0-9.-]+/g, ''));
          const currentPrice = parseFloat(newPrice.replace(/[^0-9.-]+/g, ''));
          const discountPercentage = ((originalPrice - currentPrice) / originalPrice) * 100;
          console.log(`Discount Percentage: ${discountPercentage}%`, comparePrice, originalPrice, newPrice, currentPrice);
          // convert discountPercetage to positive number if its negative
          if (priceBadgeSale) {
            priceBadgeSale.innerHTML = `Save ${Math.round(discountPercentage)}%`;
            priceBadgeSale.classList.remove('tw-hidden');
          }
        }
      
      }

      updatePriceOnInitialLoad() {
        const preselectedRadio = this.querySelector('#subscription-options input[type="radio"]:checked');
        console.log('Preselected Radio:', preselectedRadio);
        if (preselectedRadio) {
          //this.updatePriceDisplay(newPrice, comparePrice);
          this.specialPriceUpdate(preselectedRadio);
        }
        console.log('Price updated on initial load');
      }

      preselectSellingPlanFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const planId = urlParams.get('plan');
        const variantId = urlParams.get('variant');
        const option1 = urlParams.get('option1');
        const option2 = urlParams.get('option2');
        console.log('Preselecting selling plan from URL:', planId, variantId, option1, option2);
        if (planId) {
          const radio = this.querySelector(`#subscription-options input[data-plan-index="${planId}"]`);
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            console.warn(`No subscription option found for plan ID: ${planId}`);
          }
        } else {
          console.log('check the 2nd radio input #subscription-options ');
          const radio = this.querySelectorAll(`#subscription-options input[type="radio"]`);
          console.log('radio', radio[1]);
          if (radio[1]) {
            radio[1].checked = true;
            const planIndex = radio[1].dataset.planIndex;
            const url = new URL(window.location.href);
            if (planIndex) {
              url.searchParams.set('plan', planIndex);
            }
            window.history.replaceState({}, '', url.toString());
            radio[1].dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            console.warn(`No subscription option found for plan ID: ${planId}`);
          }
        }
        /* else if (variantId) {
          const radio = this.querySelector(`#subscription-options .sbs-option-wrapper input[data-variant-id="${variantId}"]`);
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            console.warn(`No subscription option found for plan ID: ${planId}`);
          }
        } */
        if (option1) {
          const allOptionPicker = this.querySelectorAll('variant-selects .product-form__input');
          const petInputs = this.querySelectorAll('variant-selects .product-form__input input[type="radio"]');
          petInputs.forEach((input) => {
            if (input.dataset.index === option1) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
        if (option2) {
          const weightSelect = this.querySelectorAll('variant-selects .product-form__input select option');
          weightSelect.forEach((option) => {
            if (option.dataset.index === option2) {
              option.setAttribute('selected', 'selected');
              option.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              option.removeAttribute('selected');
            }
          });
        }
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        /*this.setQuantityBoundries();*/
        /*if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }*/
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        //console.log('Handling option value change:', event, target, selectedOptionValues);
        if (!this.contains(event.target)) return;
        //console.log('Product info contains the event target, proceeding with option value change.');
        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        console.log('Swapping product info with URL:', productUrl, 'Update full page:', updateFullPage);
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            console.log('Updating full page with new product info');
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        console.log('Updating product info with URL:', productUrl);
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          //this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            //return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              //console.log(`Updating source from destination for ${id}`);
              if (id === 'variant-selects') {
                // console.log("inside if");
                const clone = source.cloneNode(true);
                clone.id = destination.id; // retain the ID
                destination.replaceWith(clone);
              } else {
                // console.log("inside else");
                destination.innerHTML = source.innerHTML;
              }
              // destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };
          
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('variant-selects');
          updateSourceFromDestination('dosis');
          updateSourceFromDestination('subscription-options');
          updateSourceFromDestination('Quantity-Form');
          //this.updateQuantityRules(this.sectionId, html);
          // this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          if ( !this.querySelector('#subscription-options')) {
            updateSourceFromDestination('price');
          } else {
            console.log('Skipping price update for subscription options');
            this.updatePriceOnInitialLoad();
          }

          //this.preselectSellingPlanFromUrl();  // 👈 NEW FUNCTION CALL
          this.initSellingPlanChangeListener();

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

        };
        
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {

        //const petValue = this.querySelector('variant-selects .product-form__input input[checked]').dataset.index;
        const weightValue = this.querySelector('variant-selects .product-form__input select option[selected]').dataset.index;
        
        console.log('Updating URL with:', url, 'Variant ID:', variantId, 'Option Values:', this.querySelector('variant-selects .product-form__input input[checked]'), weightValue);
        
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${`?option2=${weightValue}`}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${`?option2=${weightValue}`}`);

        let specialLink = this.querySelector('a.metafield-link');
        if (specialLink ) {
          console.log('Updating metafield links with variant and options');
          const href = new URL(specialLink .href);
          // href.searchParams.set('variant', variantId);
          // href.searchParams.set('option1', `${petValue}`);
          href.searchParams.set('option2', `${weightValue}`);
          specialLink.href = href.toString();
        }
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        /*const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));*/
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        console.log('Setting quantity boundaries for:', this.quantityInput);
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        console.log('Updating quantity rules for section:', sectionId);
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
